module.exports = __webpack_public_path__ + "img/bell-01.c566bc6f.svg";